import { useState } from "react";
import { UserPlus } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { BigButton, PageTitle } from "@/components/ui-kit";
import PatientDialog from "@/components/clinic/PatientDialog";
import PatientsTable from "@/components/clinic/PatientsTable";

export default function Patients() {
  const { t, view, can } = useApp();
  const [patient, setPatient] = useState(null);
  const livePatient = patient?.id ? view.patients?.[patient.id] || patient : patient;
  return (
    <div data-testid="patients-page">
      <PageTitle testid="patients-title" action={can("patients") && <BigButton onClick={() => setPatient({})} data-testid="patient-add-btn"><UserPlus className="w-5 h-5" />{t("add_patient")}</BigButton>}>{t("patients")}</PageTitle>
      <PatientsTable onOpen={setPatient} />
      <PatientDialog patient={livePatient} onClose={() => setPatient(null)} />
    </div>
  );
}
